import { render } from "./TopicComment.vue?vue&type=template&id=3053e786&scoped=true"
import script from "./TopicComment.vue?vue&type=script&lang=ts"
export * from "./TopicComment.vue?vue&type=script&lang=ts"

import "./TopicComment.vue?vue&type=style&index=0&id=3053e786&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3053e786"

export default script